import type { VoiceCommandIntent } from "../logic/voiceCommand";
import type { ServiceId } from "../types/domain";

export function normalizeCompanionTranscript(transcript: string) {
  return transcript
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[，。！？,.!?、：:；;]/g, "")
    .replace(/博客|博克|播课|博课|波客|拨客|播可|播科|播刻|泊客|柏客|伯客|勃客|薄客|podcast/g, "播客")
    .replace(/视屏|是频|是屏|视频频/g, "视频")
    .replace(/英伟大|英伟哒|英伟达的/g, "英伟达")
    .replace(/啥意思|什么含义/g, "什么意思");
}

export function includesCompanionPhrase(text: string, phrases: string[]) {
  return phrases.some((phrase) => text.includes(normalizeCompanionTranscript(phrase)));
}

export function createCompanionVoiceFeedback({
  companionName,
  focusService = null,
  matched,
  message,
  transcript
}: {
  companionName: string;
  focusService?: ServiceId | null;
  matched: boolean;
  message: string;
  transcript: string;
}): VoiceCommandIntent {
  return {
    transcript,
    focusService,
    matched,
    message,
    semantic: {
      source: "local",
      action: matched ? "switch_desktop" : "unknown",
      serviceId: focusService,
      destinationName: matched ? companionName : null,
      confidence: matched ? 0.92 : 0.25,
      reply: message
    },
    speechText: message,
    statePatch: {}
  };
}
